import React, { useState } from "react";
import "../styles/textInput.scss";

/**
 * TextInput — MangoTV Design System (Dark Theme)
 * Figma: input-fields component (24654:6045)
 * bg neutral/800 (#262626), border neutral/700 (#404040), rounded-lg (8px)
 * Label: Poppins SemiBold 20px, color neutral/50
 * Placeholder: Poppins Regular 14px, color neutral/500
 * Supports left icon and right icon (e.g., eye toggle for password)
 *
 * @param {string} label - Field label above input
 * @param {string} value - Input value
 * @param {function} onChange - Change handler (receives value string)
 * @param {string} placeholder - Placeholder text
 * @param {string} type - Input type (text, tel, email, password)
 * @param {React.ReactNode} leftIcon - Icon on the left side of input
 * @param {React.ReactNode} rightIcon - Icon on the right side (e.g., eye toggle)
 * @param {function} onRightIconClick - Click handler for right icon
 * @param {string} error - Error message
 * @param {boolean} disabled - Disabled state
 */
const TextInput = ({
  label,
  value = "",
  onChange,
  placeholder = "",
  type = "text",
  leftIcon = null,
  rightIcon = null,
  onRightIconClick,
  error = "",
  disabled = false,
}) => {
  const [isFocused, setIsFocused] = useState(false);

  return (
    <div
      className={`mango-input ${error ? "mango-input--error" : ""} ${
        disabled ? "mango-input--disabled" : ""
      } ${isFocused ? "mango-input--focused" : ""}`}
    >
      {/* Label */}
      {label && <label className="mango-input__label">{label}</label>}

      {/* Input Container */}
      <div className="mango-input__field-wrapper">
        <div className="mango-input__content">
          {leftIcon && (
            <span className="mango-input__icon mango-input__icon--left">
              {leftIcon}
            </span>
          )}

          <input
            className="mango-input__field"
            type={type}
            value={value}
            onChange={(e) => onChange && onChange(e.target.value)}
            placeholder={placeholder}
            onFocus={() => setIsFocused(true)}
            onBlur={() => setIsFocused(false)}
            disabled={disabled}
          />

          {rightIcon && (
            <span
              className="mango-input__icon mango-input__icon--right"
              onClick={onRightIconClick}
              role={onRightIconClick ? "button" : undefined}
              tabIndex={onRightIconClick ? 0 : undefined}
            >
              {rightIcon}
            </span>
          )}
        </div>
      </div>

      {/* Error Message */}
      {error && <span className="mango-input__error">{error}</span>}
    </div>
  );
};

export default TextInput;
